var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 60,
    viewBox: "0 0 62 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.371094,
    width: 62,
    height: 59.3768,
    rx: 10,
    fill: "#009999"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1560_55866)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.625 29.0371C15.8095 29.0371 11.0781 33.4582 11.0781 38.8923C11.0781 44.3265 15.8095 48.7475 21.625 48.7475C27.4405 48.7475 32.1719 44.3265 32.1719 38.8923C32.1719 33.4582 27.4405 29.0371 21.625 29.0371ZM26.2817 37.6955L20.813 42.8057C20.5842 43.0195 20.2843 43.1264 19.9844 43.1264C19.6845 43.1264 19.3845 43.0195 19.1558 42.8057L16.812 40.6156C16.3544 40.188 16.3544 39.4947 16.812 39.067C17.2696 38.6395 18.0116 38.6395 18.4693 39.067L19.9844 40.4828L24.6245 36.147C25.0821 35.7194 25.8241 35.7194 26.2818 36.147C26.7394 36.5746 26.7394 37.268 26.2817 37.6955Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9375 20.8613C41.2903 20.8613 40.7656 20.371 40.7656 19.7663V11.3711H23.9687C22.0302 11.3711 20.4531 12.8448 20.4531 14.6562V26.8977C20.8392 26.865 21.2299 26.8474 21.625 26.8474C25.6194 26.8474 29.1951 28.5539 31.5614 31.2275H44.2812C44.9284 31.2275 45.4531 31.7178 45.4531 32.3226C45.4531 32.9273 44.9284 33.4176 44.2812 33.4176H33.1053C33.8378 34.7532 34.3102 36.2329 34.4618 37.7977H44.2812C44.9284 37.7977 45.4531 38.288 45.4531 38.8927C45.4531 39.4974 44.9284 39.9877 44.2812 39.9877H34.4618C34.1113 43.6042 32.0435 46.7642 29.028 48.7479H47.4062C49.3448 48.7479 50.9219 47.2742 50.9219 45.4628V20.8613H41.9375ZM44.2812 26.8474H27.0937C26.4466 26.8474 25.9219 26.3572 25.9219 25.7524C25.9219 25.1477 26.4466 24.6574 27.0937 24.6574H44.2812C44.9284 24.6574 45.4531 25.1477 45.4531 25.7524C45.4531 26.3572 44.9284 26.8474 44.2812 26.8474Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1094 12.0117V18.6707H50.2352L43.1094 12.0117Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1560_55866"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 37.3768,
    fill: "white",
    transform: "translate(11 11.3711)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/Icon-4.a2458469140941c276b1285bf38189a4.svg";
export { ForwardRef as ReactComponent };